import Dot from "../../../Components/Dot/Dot";
import style from "./Notification.module.css";
import Svg from "../../../Components/Svg/Svg";
import User from "../../../Services/User";
import SvgOptions from "../../../Components/Svg/SvgOptions";
const Notification = ({ type, children, onClick }) => {
	const formatTime = (dateString) => {
		const date = new Date(dateString);
		let hours = date.getHours();
		const minutes = date.getMinutes().toString().padStart(2, "0");
		const ampm = hours >= 12 ? "PM" : "AM";
		hours = hours % 12 || 12;
		return `${hours}:${minutes}${ampm}`;
	};
	const { staff, title, createdAt } = children;
	const biodata = User.getBiodata();
	// const dotStyle={
	//     backgroundColor:"var(--electricblue)",
	//     border:"none",
	//     width:"6px",
	//     height:"6px",
	//     transform:"translate(-10px, 6px)"
	// }
	let icon = null;
	if (typeof type === "object") {
		icon = type.icon;
		// dotStyle.backgroundColor=type.color;
	}
	return (
		<div
			onClick={() => onClick(children)}
			className={style[typeof type === "object" ? type.name : "info"]}
		>
			{/* <div className={style.band}></div> */}
			<div className={style.content}>
				<div className={style.subContent}>
					{/* <Dot style={dotStyle}></Dot> */}
					<div className={style.circle}>
						{" "}
						<Svg>{SvgOptions.CircleNotification}</Svg>
					</div>

					<div className={style.margin}>
						<div className={style.text}>
							<span>{staff.firstname + " " + staff.lastname}</span> {title}
						</div>
						<div className={style.time}>{formatTime(createdAt)}</div>
					</div>
				</div>
				<Svg>{SvgOptions.Arrow}</Svg>
			</div>
		</div>
	);
};
export default Notification;
